// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class CardV1SmsTextSendSendResponse {
    static getAttributeTypeMap() {
        return CardV1SmsTextSendSendResponse.attributeTypeMap;
    }
}
CardV1SmsTextSendSendResponse.discriminator = undefined;
CardV1SmsTextSendSendResponse.additionalProperties = false;
CardV1SmsTextSendSendResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "object"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
];
//# sourceMappingURL=cardV1SmsTextSendSendResponse.js.map